// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_fh","gallery__header":"c-p_fi","gallery__thumbs":"c-p_fj"};